/**
 * Renders the partner's online program name inside a hero `<h1>` for crawlers
 * and screen readers, without affecting the visual design.
 *
 * Whether a given hero wants this is an editorial judgement, not something that
 * can be derived: many headings already name the program (`Case Western Reserve
 * Pre-College Program`), overlap part of it (`Online STEM Programs` under a
 * `… Online Program` brand), or imply it. Each of those reads badly when the
 * name is injected anyway. So it is controlled per slice by the
 * `prefix_partner_name` Boolean in the Hero models.
 *
 * Has no hooks or state, so it is safe in both server and client components.
 */
export const PartnerNamePrefix = function PartnerNamePrefix({
  enabled,
  name,
}: {
  /**
   * The slice's `prefix_partner_name` value. Prismic omits the field on
   * documents published before it was added, so only an explicit `false`
   * suppresses the prefix.
   */
  enabled: boolean | null | undefined;
  name: string;
}) {
  if (!name || enabled === false) {
    return null;
  }

  // The em dash separates the name from the visible heading text when read
  // aloud, and the surrounding spaces keep the words from running together.
  return <span className="sr-only">{`${name} — `}</span>;
};
